import React, { lazy, useContext, useEffect, useState } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { ChatProvider } from '../context/ChatContext'
import { PageTitle } from '../layout/core'
import { MasterLayout } from '../layout/MasterLayout'
import { ProfilePage } from '../pages/profile/ProfilePage'
import LoadingSpinner from '../components/LoadingSpinner'
import VerifyEmail from '../components/auth/components/VerifyEmail'
import { AUTH_TOKEN } from '../constants'
import NewClientPage from '../pages/Multi-Step'
import MainRoute from '../pages/processAutomation/MainRoute'
import { usePlan } from '../context/PlanContext'
import UserContext from '../context/UserContext'
import WhatsAppBots from '../pages/whatsAppBots'
import FranchisePage from '../pages/franchise'
import ViewAllClients from '../pages/franchise/FranchiseAdminClients/ViewAllClients'
import ExcelAnalyticsIndex from '../pages/excelAnalytics'
import ExcelTableContainer from '../components/excelAnalytics/Table/index'
import FranchiseAgreementDetails from '../pages/franchise/FranchiseAdminClients/FranchiseAgreementDetails'
import Subscriptions from '../pages/Subscription/Index'
import RolePermissionContext from '../context/RolePermissionContext'
import AccountPage from '../pages/account/Index'
import InitialSubscription from '../pages/initialSubscription/Index'

// ticketing
// import CustomerSupport from '../pages/customerSupport/CustomerSupport'
import InstagramBots from '../pages/instagram'
import Tickets from '../components/tickets/ticketSupportEngineer/Tickets'
// import AdminTicket from '../components/tickets/ticketAdminTicket/AdminTicket'
// import TicketHistory from '../components/tickets/ticketsData/TicketHistory'
import TicketTool from '../pages/customerSupport'
import AdminTicketIndex from '../components/tickets/ticketAdminTicket'
import AgentMainDashboard from '../pages/agentMainDashboard'
import Configuration from '../pages/configuration'
import Forecast from '../components/excelAnalytics/Table/Forecast'
import ElearningPage from '../pages/Elearning'
import PaymentPage from '../pages/paymentDetails'
import YoutubePage from '../pages/youtube/YoutubePage'
import VideoCommentsPage from '../pages/youtube/VideoCommentsPage'
import TicketDetails from '../pages/ticketDetails'
import AIBotsPage from '../pages/aiBotbuilder'
import FilesAssetsPage from '../pages/filesAssets/FilesAssetsPage'
import Workflow from '../pages/workflow'
import { AssessmentRoutes } from '../pages/assessments/AssessmentRoute'

const LeadPage = lazy(() => import('../pages/leads/index'))
const Dashboard = lazy(() => import('../pages/dashboard/Dashboard'))
const AdvancedDashboard = lazy(() => import('../pages/advancedDashboard/advancedDashboard'))
const AllChats = lazy(() => import('../pages/conversations/index'))
const BotsPage = lazy(() => import('../pages/bots'))
const IntegrationsPage = lazy(() => import('../pages/otherIntegrate'))
const TeamsPage = lazy(() => import('../pages/teams/TeamsPage'))
const UsersPage = lazy(() => import('../pages/users/UsersPage'))
const WebHooks = lazy(() => import('../pages/webHooks'))
const ClientOnboard = lazy(() => import('../pages/clientOnboard'))
const SuperAdminDashboard = lazy(() => import('../pages/SuperAdminDashboard'))
const Roles = lazy(() => import('../pages/roles'))
const Packages = lazy(() => import('../pages/packages'))
const Modules = lazy(() => import('../pages/modules'))

const PrivateRoutes: React.FC = () => {
  const { data, currentUser, loadingUser, errorLoadingUser } = useContext(UserContext)
  const { data2 } = useContext(RolePermissionContext)
  const { currentPlan } = usePlan()
  // const { loading, error, data } = useQuery(GET_USER_BY_ID)
  const [toNavigate, setToNavigate] = useState<any>('')

  // useEffect(() => {
  //   if (data2) {
  //     const sideMenuListWithAccess = getSideMenuList(data2)
  //     setToNavigate(sideMenuListWithAccess?.to)
  //   }
  // }, [data2])

  // function getSideMenuList(jsonData: any) {
  //   if (jsonData && jsonData?.getPermissionsByRole && jsonData?.getPermissionsByRole?.data) {
  //     const permissionData = jsonData?.getPermissionsByRole?.data?.permissionName
  //     const roleName = Object?.keys(permissionData)[0] // Get the first key
  //     const features = permissionData[roleName]?.features

  //     for (const feature in features) {
  //       if (features.hasOwnProperty(feature) && features[feature]?.isAccess) {
  //         const sideMenu = features[feature]?.sideMenuList
  //         if (sideMenu) {
  //           return sideMenu
  //         }
  //       }
  //     }
  //   }

  //   return null // Return null if no valid sideMenuList object is found
  // }

  // if (loadingUser) {
  //   return <LoadingSpinner />
  // }

  // if (errorLoadingUser) {
  //   console.error(errorLoadingUser)
  //   localStorage.removeItem(AUTH_TOKEN)
  //   setTimeout(() => {
  //     document.location.reload()
  //   }, 500)
  // }

  // if (data2) {
  //   // console.log(data2)
  // }

  // const permissionNames = data2?.getPermissionsByRole?.data?.permissionName

  // // const roleNames = Object?.keys(permissionNames)

  // // const features = permissionNames[roleNames[0]]?.features

  // // const isAdmin = currentUserRole.admin
  // // const isSuperAdmin = currentUserRole.superAdmin
  // // const isAgentOrOperator = currentUserRole.agent || currentUserRole.operator
  // // const isFranchiseAdmin = currentUserRole.franchiseAdmin

  // let reportAnalyticsPermission = currentPlan?.package?.feature?.reportingAnalytics
  // console.log(toNavigate)

  // const accessibleFeatures = Object.entries(permissionNames).reduce(
  //   (acc: any[], [_, value]: any) => {
  //     const features = value.features
  //     const accessible = Object.entries(features)
  //       .filter(([_, feature]: any) => feature.isAccess)
  //       .map(([featureName, _]) => featureName)
  //     return [...acc, ...accessible]
  //   },
  //   []
  // )
  // console.log(accessibleFeatures)
  useEffect(() => {
    if (data2) {
      const sideMenuListWithAccess = getSideMenuList(data2)
      setToNavigate(sideMenuListWithAccess?.to)
    }
  }, [data2])

  function getSideMenuList(jsonData: any) {
    if (jsonData && jsonData.getModuleAcessByRole && jsonData.getModuleAcessByRole.data) {
      const permissions = jsonData.getModuleAcessByRole.data

      const accessibleModules = permissions.filter(
        (permission: any) =>
          permission.isAccess &&
          permission.module?.sideMenu &&
          Object.keys(permission.module.sideMenu).length > 0
      )

      if (accessibleModules.length > 0) {
        accessibleModules.sort((a: any, b: any) => a.order - b.order)
        return accessibleModules[0].module.sideMenu
      }
    }

    return null
  }

  if (loadingUser) {
    return <LoadingSpinner />
  }

  if (errorLoadingUser) {
    console.error(errorLoadingUser)
    localStorage.removeItem(AUTH_TOKEN)
    setTimeout(() => {
      document.location.reload()
    }, 500)
  }

  const accessibleFeatures =
    data2?.getModuleAcessByRole?.data?.filter((feature: any) => feature.isAccess) || []
  const reportAnalyticsPermission = currentPlan?.package?.feature?.reportingAnalytics

  return (
    <ChatProvider>
      <Routes>
        <Route path='onboarding/*' element={<NewClientPage />} />
        <Route path='change-plan' element={<InitialSubscription />} />
        <Route
          path='verify-email'
          element={<VerifyEmail user={currentUser} currentPlan={currentPlan} />}
        />
        {/* <Route path='' */}

        <Route element={<MasterLayout />}>
          <Route
            path='auth/*'
            element={
              <>
                {!!data?.getUserById && !data?.getUserById?.emailVerified && (
                  <Navigate to='/verify-email' />
                )}
                {!!data?.getUserById &&
                  !!data?.getUserById?.emailVerified &&
                  !data?.getUserById?.onboardingDone && (
                    <Navigate to='/onboarding/personal-details' />
                  )}

                {/* {!!data2 &&
                !!data?.getUserById &&
                !!data?.getUserById?.emailVerified &&
                !!data?.getUserById?.onboardingDone ? (
                  currentPlan?.clientPackageId === null ? (
                    <Navigate to='/change-plan'/>
                  ) : (
                    <Navigate to={toNavigate} />
                  )
                ) : null} */}
                {!!data2 &&
                  !!data?.getUserById &&
                  !!data?.getUserById?.emailVerified &&
                  !!data?.getUserById?.onboardingDone && <Navigate to={toNavigate} />}
              </>
            }
          />

          {!!data?.getUserById &&
            !!data?.getUserById?.emailVerified &&
            !!data?.getUserById?.onboardingDone && (
              <>
                {accessibleFeatures?.map((feature: any) => {
                  const featureName = feature.module.name
                  switch (featureName) {
                    case 'Dashboard':
                      return (
                        <>
                          <Route key={featureName} path='/dashboard' element={<Dashboard />} />
                          <Route
                            path='dashboard/advanceddashboard'
                            element={
                              reportAnalyticsPermission === 'ADVANCE' ? (
                                <AdvancedDashboard />
                              ) : (
                                <div>Upgrade your plan to access this feature.</div>
                              )
                            }
                          />
                        </>
                      )
                    case 'All-leads':
                      return <Route key={featureName} path='Leads' element={<LeadPage />} />
                    case 'Chat-history':
                    case 'Human-hand-off':
                      return (
                        <Route key={featureName} path='/conversations/*' element={<AllChats />} />
                      )
                    case 'Bot-Builder':
                      return <Route key={featureName} path='bots/*' element={<BotsPage />} />
                    case 'WhatsApp-Bot-Builder':
                      return (
                        <Route
                          key={featureName}
                          path='whatsapp-bots/*'
                          element={<WhatsAppBots />}
                        />
                      )
                    case 'Instagram-Bot-Builder':
                      return (
                        <Route
                          key={featureName}
                          path='instagram-bots/*'
                          element={<InstagramBots />}
                        />
                      )

                    case 'Franchise Clients':
                      return (
                        <Route
                          path='franchise-clients'
                          element={
                            <>
                              <ViewAllClients franchiseId={data.getUserById.franchiseId} />
                              <>
                                <PageTitle breadcrumbs={[]}>Clients Details</PageTitle>
                              </>
                            </>
                          }
                        />
                      )

                    case 'Teams':
                      return <Route key={featureName} path='teams' element={<TeamsPage />} />
                    case 'Users':
                      return (
                        <>
                          <Route key={featureName} path='users' element={<UsersPage />} />
                        </>
                      )
                    case 'Profile':
                      return <Route key={featureName} path='/profile' element={<ProfilePage />} />
                    case 'Process-Automation':
                    case 'Document-Managament-System':
                    case 'Bussiness-Process-Automation':
                    case 'Optical-Character-Recongnition':
                    case 'Resume-Parser':
                    case 'Form-Builder':
                    case 'IBot-Assistant':
                      return <Route path='automation/*' element={<MainRoute />} />

                    case 'Other-Integration':
                      return (
                        <Route
                          key={featureName}
                          path='integrations/*'
                          element={<IntegrationsPage />}
                        />
                      )
                    case "Webhook's-Doc":
                      return <Route key={featureName} path='webhooks' element={<WebHooks />} />

                    case 'Helpcenter':
                      return (
                        <Route
                          path='helpcenter'
                          element={<PageTitle breadcrumbs={[]}>Helpcenter</PageTitle>}
                        />
                      )

                    case 'Accounts':
                      return (
                        <>
                          <Route key={featureName} path='account/*' element={<AccountPage />} />
                        </>
                      )

                    case 'Clients':
                      return (
                        <Route key={featureName} path='/clients/*' element={<ClientOnboard />} />
                      )
                    case 'SuperAdminDashboard':
                      return (
                        <Route
                          key={featureName}
                          path='/superAdmin/*'
                          element={<SuperAdminDashboard />}
                        />
                      )
                    case 'Roles':
                      return <Route key={featureName} path='/roles' element={<Roles />} />
                    case 'Packages':
                      return <Route key={featureName} path='/packages' element={<Packages />} />
                    case 'Modules':
                      return <Route key={featureName} path='/modules' element={<Modules />} />

                    case 'Franchise':
                      return <Route path='franchise/*' element={<FranchisePage />} />
                    case 'Agreement-Details':
                      return (
                        <Route
                          path='/Agreement-Details'
                          element={
                            <>
                              <FranchiseAgreementDetails
                                franchiseId={data.getUserById.franchiseId}
                              />
                              <>
                                <PageTitle breadcrumbs={[]}>Franchise Agreement Details</PageTitle>
                              </>
                            </>
                          }
                        />
                      )
                    case 'Franchise Clients':
                      return (
                        <Route
                          path='/franchise-clients'
                          element={
                            <>
                              <ViewAllClients franchiseId={data.getUserById.franchiseId} />
                              <>
                                <PageTitle breadcrumbs={[]}>Franchise Clients</PageTitle>
                              </>
                            </>
                          }
                        />
                      )

                    case 'Admin-Tickets':
                      return (
                        <>
                          <Route path='ticket' element={<TicketTool />} />
                        </>
                      )

                    case 'SuperAdmin-Tickets':
                      return <Route path='/admin-tickets' element={<AdminTicketIndex />} />

                    case 'Support-Tickets':
                      return <Route path='/support-tickets' element={<Tickets />} />
                    case 'Excel-Analytics':
                      return (
                        <>
                          <Route path='excel' element={<ExcelAnalyticsIndex />} />
                          <Route path='/excel_table' element={<ExcelTableContainer />} />
                          <Route path='/excel_table/forecast' element={<Forecast />} />
                        </>
                      )
                    case 'Report':
                      return (
                        <>
                          <Route path='report/*' element={<AgentMainDashboard />} />
                        </>
                      )
                    case 'Configuration':
                      return (
                        <>
                          <Route path='configuration' element={<Configuration />} />
                        </>
                      )
                    case 'Payment-Details':
                      return (
                        <>
                          <Route path='payment-details' element={<PaymentPage />} />
                        </>
                      )
                    case 'Youtube':
                      return (
                        <>
                          <Route path='/youtube' element={<YoutubePage />} />
                          <Route path='/youtube/video/:videoId' element={<VideoCommentsPage />} />
                        </>
                      )
                    case 'Ticket Details':
                      return (
                        <>
                          <Route path='ticket-details' element={<TicketDetails />} />
                        </>
                      )
                    default:
                      return null
                  }
                })}

                <Route path='/learning/*' element={<ElearningPage />} />
                <Route path='/files-assets' element={<FilesAssetsPage />} />

                <Route path='/subscription' element={<Subscriptions />} />
                <Route path='ai-bots/*' element={<AIBotsPage />} />
                <Route path='assessments/*' element={<AssessmentRoutes />} />
                <Route index element={<Navigate to='dashboard' />} />
                <Route path='*' element={<Navigate to='/error/404' />} />
              </>
            )}
        </Route>
      </Routes>
    </ChatProvider>
  )
}

export { PrivateRoutes }
